function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M67.3741 32.821C70.6988 51.3888 60.8473 64.9241 36.1512 68.5683C11.2787 71.3448 3.69344 60.7593 0.1654 35.9445C-1.24579 14.4267 6.16303 5.75025 30.5063 0.370862C49.9104 -1.53802 59.6125 3.14735 67.3741 32.821Z",
  fill: "#F0E36C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1058 49.4074H48.8939C49.2138 49.4074 49.4731 49.1481 49.4731 48.8282V16.5577C49.4731 16.2378 49.2138 15.9785 48.8939 15.9785H19.1058C18.7859 15.9785 18.5266 16.2378 18.5266 16.5577V48.8282C18.5266 49.1481 18.7859 49.4074 19.1058 49.4074ZM48.3147 48.249H19.685V17.1369H48.3147V48.249Z",
  fill: "#301D31",
  stroke: "#301D31"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1058 41.133H48.8939C49.2138 41.133 49.4731 40.8737 49.4731 40.5538V23.1774C49.4731 22.8575 49.2138 22.5981 48.8939 22.5981H19.1058C18.7859 22.5981 18.5266 22.8575 18.5266 23.1774V40.5538C18.5266 40.8737 18.7859 41.133 19.1058 41.133ZM48.3147 39.9746H19.685V23.7566H48.3147V39.9746Z",
  fill: "#301D31",
  stroke: "#301D31"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M39.7922 55.2001H45.5844C45.9043 55.2001 46.1636 54.9408 46.1636 54.6209V48.8287C46.1636 48.5088 45.9043 48.2495 45.5844 48.2495H39.7922C39.4723 48.2495 39.213 48.5088 39.213 48.8287V54.6209C39.213 54.9408 39.4723 55.2001 39.7922 55.2001ZM45.0051 54.0417H40.3714V49.4079H45.0051V54.0417Z",
  fill: "#301D31",
  stroke: "#301D31"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4158 55.2001H28.2079C28.5278 55.2001 28.7871 54.9408 28.7871 54.6209V48.8287C28.7871 48.5088 28.5278 48.2495 28.2079 48.2495H22.4158C22.0959 48.2495 21.8365 48.5088 21.8365 48.8287V54.6209C21.8365 54.9408 22.0959 55.2001 22.4158 55.2001ZM27.6287 54.0417H22.995V49.4079H27.6287V54.0417Z",
  fill: "#301D31",
  stroke: "#301D31"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M43.1013 46.9248C44.3332 46.9248 45.3354 45.9226 45.3354 44.6907C45.3354 43.4587 44.3332 42.4565 43.1013 42.4565C41.8694 42.4565 40.8672 43.4587 40.8672 44.6907C40.8672 45.9226 41.8694 46.9248 43.1013 46.9248ZM43.1013 43.615C43.6945 43.615 44.177 44.0975 44.177 44.6907C44.177 45.2838 43.6945 45.7663 43.1013 45.7663C42.5082 45.7663 42.0257 45.2838 42.0257 44.6907C42.0257 44.0975 42.5082 43.615 43.1013 43.615Z",
  fill: "#301D31",
  stroke: "#301D31"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M24.8982 46.9248C26.1301 46.9248 27.1323 45.9226 27.1323 44.6907C27.1323 43.4587 26.1301 42.4565 24.8982 42.4565C23.6663 42.4565 22.6641 43.4587 22.6641 44.6907C22.6641 45.9226 23.6663 46.9248 24.8982 46.9248ZM24.8982 43.615C25.4913 43.615 25.9739 44.0975 25.9739 44.6907C25.9739 45.2838 25.4913 45.7663 24.8982 45.7663C24.3051 45.7663 23.8225 45.2838 23.8225 44.6907C23.8225 44.0975 24.3051 43.615 24.8982 43.615Z",
  fill: "#301D31",
  stroke: "#301D31"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M29.8626 45.2702H38.1371C38.457 45.2702 38.7163 45.0109 38.7163 44.691C38.7163 44.3711 38.457 44.1118 38.1371 44.1118H29.8626C29.5427 44.1118 29.2834 44.3711 29.2834 44.691C29.2834 45.0109 29.5427 45.2702 29.8626 45.2702Z",
  fill: "#301D31",
  stroke: "#301D31"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8527 36.9956H19.1054C19.4252 36.9956 19.6846 36.7363 19.6846 36.4164V28.9694C19.6846 28.6495 19.4252 28.3901 19.1054 28.3901H16.8527C15.4941 28.3901 14.3889 29.4954 14.3889 30.854V34.5317C14.3889 35.8904 15.4941 36.9956 16.8527 36.9956ZM18.5261 35.8372H16.8527C16.1329 35.8372 15.5473 35.2515 15.5473 34.5317V30.854C15.5473 30.1342 16.1329 29.5486 16.8527 29.5486H18.5261V35.8372Z",
  fill: "#301D31",
  stroke: "#301D31"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M48.8939 36.9956H51.1465C52.505 36.9956 53.6104 35.8904 53.6104 34.5317V30.854C53.6104 29.4954 52.505 28.3901 51.1465 28.3901H48.8939C48.574 28.3901 48.3147 28.6495 48.3147 28.9694V36.4164C48.3147 36.7363 48.574 36.9956 48.8939 36.9956ZM51.1465 29.5486C51.8663 29.5486 52.4519 30.1342 52.4519 30.854V34.5317C52.4519 35.2515 51.8663 35.8372 51.1465 35.8372H49.4731V29.5486H51.1465Z",
  fill: "#301D31",
  stroke: "#301D31"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M38.9644 33.5207C39.1322 33.5207 39.2986 33.4482 39.413 33.3083C39.6156 33.0607 39.5791 32.6958 39.3315 32.4933L31.4432 26.0392C31.1956 25.8366 30.8307 25.873 30.6281 26.1207C30.4255 26.3682 30.462 26.7332 30.7096 26.9357L38.5979 33.3898C38.7056 33.4778 38.8354 33.5207 38.9644 33.5207Z",
  fill: "#301D31",
  stroke: "#301D31"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M38.2472 37.823C38.4149 37.823 38.5813 37.7506 38.6957 37.6106C38.8983 37.3631 38.8618 36.9982 38.6142 36.7955L30.7259 30.3414C30.4783 30.1389 30.1134 30.1753 29.9108 30.4229C29.7082 30.6705 29.7447 31.0354 29.9923 31.238L37.8806 37.6921C37.9883 37.7801 38.1182 37.823 38.2472 37.823Z",
  fill: "#301D31",
  stroke: "#301D31"
});

function SvgIconBus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBus);
export default __webpack_public_path__ + "static/media/icon_bus.b2e7db0e.svg";
export { ForwardRef as ReactComponent };